import React from "react";
import {NavLink, Link} from 'react-router-dom';
import Moment from 'moment-timezone';
import { extendMoment } from 'moment-range';
import InstagramEmbed from 'react-instagram-embed';
import $ from 'jquery';

import * as configActions from './../actions/configActions';
import * as configHelper from "./configHelper";
const moment = extendMoment(Moment);

export var bedsDisplay = (config, bedStr, room = false) => {
	if (!config || !config.bed_types)
		return "";

	if (!(bedStr instanceof String)) {
		bedStr =  bedStr.toString();
	}

	var beds = bedStr.split(',').map(bed => parseFloat(bed));
	var names = [];
	
	for (var i = beds.length - 1; i >= 0; i--) {
		for (var j = config.bed_types.length - 1; j >= 0; j--) {
			if (config.bed_types[j]["value"] === beds[i]) {
            if (room) 
               names.push("Room for Rent in " + config.bed_types[j]["name"] + (config.bed_types[j]["value"] >= 1 ? " Bed" : ""));
            else
               names.push(config.bed_types[j]["name"]);
         }
		}
	}
	names = names.reverse();

	return names.length ? names.join(', ') : bedStr;
};

export var listDateDisplay = (listDate) => {
	if (listDate && listDate.length > 0) {
		var date = moment(listDate, ['MM/DD/YYYY', 'YYYY-MM-DD']);
		var now = new moment();
		if (now.unix() >= date.unix()) {
			return "NOW";
		} else {
			return listDate;
		}
	}
	else {
		return "";
	}
};

export var parkingDisplay = (config, val) => {
	if (!config || !config.parking_availabilities)
		return "";

	for (var j = config.parking_availabilities.length - 1; j >= 0; j--) {
		if (config.parking_availabilities[j]["value"] === val)
			return config.parking_availabilities[j]["name"];
	}

	return "";
};

export var utcDateDisplay = (date) => {
	if (date && date.length > 0) {
		return moment.tz(date, 'Europe/London').format('MM/DD/YYYY');
	}
	else
		return "";
};

export var nameDisplay = (person) => {
	var name = person.first_name;

	if (name === "See Original Email")
		name += " Below";

	if (person.last_name && person.last_name.length > 0)
		name += " " + person.last_name;

	return name;
};

export var renderBackButton = (handleBack = null) => {
	return <div className="item back-button" key="back">
         <button className="ui secondary button" onClick={e => {
            if (handleBack)
               handleBack();
            else
               window.history.go(-1); 
            return false;
         }}><i className="ygl-icon google-back"></i></button>
		</div>;	
};

export var renderDefaultButtonsGroup = (buttons = []) => {
	return <div className="header-buttons-menu">
		{renderBackButton()}
		{buttons}
	</div>;
};

export const menuLinks = (config, dispatch) => {
	var links = [];

	if (!config.isLoaded)
		return links;

	links.push(<NavLink key="Dashboard" className="item important" activeClassName="active" exact to="/">Dashboard</NavLink>);
	links.push(<a key="Rentals" className="item important" activeClassName="active" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "rentals"}>Rentals</a>);
	
	if (config.isLoaded && config.account.is_premium)
		links.push(<a key="Ads" className="item ads" activeClassName="active" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "ads"}>Ads</a>);
		
	if (config.isLoaded && !config.account.syndicate.is_share_all && config.account.is_premium)
		links.push(<a key="Rental Groups" className="item" activeClassName="active" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "rental-groups"}>Rental Groups</a>);
		
	if (!config.isLoaded || config.account.is_premium)
      links.push(<a key="Leads" className="item important" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "leads"}>
         Leads
      </a>);

	if (!config.isLoaded || configHelper.canSearchLandlord(config))
		links.push(<a key="Landlords" className="item important" activeClassName="active" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "landlords"}>Landlords</a>)
		
	if (!config.isLoaded || config.account.is_premium || config.account.syndicate.is_share_all)
		links.push(<a key="Documents" className="item important documents-menu-item" activeClassName="active" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "documents"}>Documents</a>);

	if (!config.isLoaded || config.account.syndicate.is_share_all)
		links.push(<a key="Brokers" className="item important brokers" activeClassName="active" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "brokers"}>Brokers</a>);

	if (configHelper.canAccessCreditReports(config))
		links.push(<a key="Credit Reports" className="item important credit-reports" activeClassName="active" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "credit-reports"}>
				Credit Reports
			</a>);

	if (config.isLoaded && config.account.is_show_deals)
		links.push(<a key="deals" className="item important deals" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "deals"}>
         Deals
      </a>);
			
	if (config.isLoaded && config.account.is_show_complexes)
		links.push(<a key="complexes" className="item important complexes" href={process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "complexes"}>
			Complexes
		</a>);
	
	links.push(<a id="whatsnew" key="whatsnew" className="item important whatsnew" href="https://app.getbeamer.com/yougotlistings/en" target="_blank" rel="noopener noreferrer">What's New</a>);

	return links;
};


// WEBPACK FOOTER //
// ./src/helpers/displayHelper.js